module.exports = __webpack_public_path__ + "static/media/car-green.8e27b871.svg";